// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SocialNetworks_wrapper__3LmuU","img":"SocialNetworks_img__VQaYb"};